<!--
 * @Author: 张怀宇
 * @Date: 2020-06-30 09:54:33
 * @LastEditors: 张怀宇
 * @LastEditTime: 2020-07-15 17:10:24
--> 
<template>
  <div>
    <BreadCrumb class="bread" :breads="['广告管理','广告申请']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">广告申请</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="广告名称">
            <el-input v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="search.status">
              <el-option v-for="(label, key) in adStatus" :key="key" :value="key" :label="label"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
            <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="operate-con">
        <el-button size="small" class="add" @click="openAdd">新增</el-button>
      </div>
      <div class="table-con">
        <el-table :data="tableList" stripe>
          <el-table-column type="index" label="序号" align="center" :index="indexMethod"></el-table-column>
          <el-table-column label="广告标题" align="center" prop="title"></el-table-column>
          <el-table-column label="广告类型" align="center" prop="adv_type">
            <div slot-scope="scope">{{advType[scope.row.adv_type]}}</div>
          </el-table-column>
          <el-table-column label="广告品牌" align="center" prop="brand"></el-table-column>
          <el-table-column label="审核状态" align="center" prop="status">
            <div slot-scope="scope">{{adStatus[scope.row.status]}}</div>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="created_at"></el-table-column>
          <el-table-column label="创建人" align="center" prop="rel_name"></el-table-column>
          <el-table-column label="操作" align="center" prop="operate">
            <div slot-scope="scope">
              <el-button size="small" type="primary" @click="apply(scope.row.id)" v-show="scope.row.status === 'WAIT_REVIEW'">提交审核</el-button>
              <el-button size="small" type="primary" @click="update(scope.row.id)" v-show="scope.row.status === 'WAIT_REVIEW'">修改</el-button>
              <el-button size="small" @click="onView(scope.row.id)">查看</el-button>
              <el-button size="small" type="danger" @click="remove(scope.row.id)" v-show="scope.row.status === 'WAIT_REVIEW' || scope.row.status === 'FAIL'">删除</el-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import alert from "@/plugins/alert";
export default {
  mixins: [listMixin],
  data() {
    return {
      search: {
        status: ""
      },
      advType: {
        VIDEO: "视频",
        IMAGE: "图片"
      },
      adStatus: {
        WAIT_REVIEW: "待审核",
        UNDER_REVIEW: "审核中",
        REVIEWED: "已审核",
        FAIL: "审核失败"
      }
    };
  },

  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
  },
  methods: {
    searchForm() {
      this.search.page_index = 1;
      this.getData();
    },
    getData() {
      this.getTableData(apis.advert_list, "get", this.search);
    },
    reset() {
      this.search = {
        status: ""
      };
      this.getData();
    },
    openAdd() {
      this.$router.push({
        name: "applyAd"
      });
    },
    apply(id) {
      this.$axios.get(`${apis.apply_ad}${id}`).then(res => {
        this.$message.success("提交成功");
        this.getData();
      });
    },
    update(id) {
      this.$router.push({
        name: "applyAd",
        query: {
          id: id,
          operate: "update"
        }
      });
    },
    onView(id) {
      this.$router.push({
        name: "applyAd",
        query: {
          id: id,
          operate: "look"
        }
      });
    },
    remove(id) {
      alert.deleteAlert().then(next => {
        this.$axios.delete(apis.delete_advert + "/" + id).then(res => {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getData();
        });
      });
    }
  }
};
</script>

<style scoped>
</style>